import LocalStorageWrapper from "./Vault";

export default new LocalStorageWrapper();
